import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36100efe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  slot: "end",
  style: {"width":"48px"}
}, null, -1))

import {
	IonBackButton,
	IonHeader,
	IonToolbar,
	IonButtons,
	IonTitle,
} from "@ionic/vue";
import { withDefaults } from "vue";

interface IProps {
	whiteBackground?: boolean;
	primaryColor?: boolean;
	title?: string;
	colorTitle?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BackHeader',
  props: {
    whiteBackground: { type: Boolean },
    primaryColor: { type: Boolean, default: false },
    title: null,
    colorTitle: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonHeader), {
    class: _normalizeClass(["ion-no-border", {
			'primary-color': __props.primaryColor,
			'white-background': __props.whiteBackground,
		}])
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonToolbar), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonButtons), { slot: "start" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonBackButton), {
                text: "",
                "default-href": "/login"
              })
            ]),
            _: 1
          }),
          (__props.title)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_unref(IonTitle), {
                  class: _normalizeClass(["text-base", __props.colorTitle])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.title), 1)
                  ]),
                  _: 1
                }, 8, ["class"]),
                _hoisted_1
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})